// 路由信息，纯JS对象，方便读取路由信息
import type { RouterMode } from 'vue-router';
import Home from './views/Home.vue';
export default {
  mode: 'history' as RouterMode,
  routes: [

    // restful路径使用动态路由参数
    {
      path: '/c/:encryptedInfo(.*)',
      name: 'home',
      component: Home,
    },
    // 默认路径
    {
      path: '*',
      name: 'default',
      component: Home,
    },
  ],
};
